import { HydraState } from '@src/constants';
const getFormSectionQuestions = async ({
	form,
	locale,
	enableHydra = false,
	sessionId = 'N/A',
}: {
	form: string;
	locale?: string | string[];
	enableHydra?: boolean;
	sessionId: string | undefined;
}) => {
	try {
		const queryParams = `?form=${form}&language=${locale}`;
		const updatedCall = await fetch(
			process.env.APP_PATH + '/api/clear-choice/get-patient-questions/' + queryParams,
			{
				headers: {
					'X-Session-Id': sessionId,
					hydra: enableHydra ? HydraState.ON : HydraState.OFF,
				},
				method: 'GET',
			}
		);

		const updatedData = (await updatedCall.json()) as any;

		return updatedData;
	} catch (error) {
		if (error instanceof Error) {
			console.error(`Failed Loading Form Questions: ${error.message}`);
		}
		return [];
	}
};

export { getFormSectionQuestions };
